"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMuiLicense = void 0;
var _xLicensePro = require("@mui/x-license-pro");
var _constants = require("./constants");
var setMuiLicense = exports.setMuiLicense = function setMuiLicense(key) {
  _xLicensePro.LicenseInfo.setLicenseKey(key || _constants.MUI_PRO_KEY);
};